const KEY = 'em_marketing_consent';

export type MarketingConsent = 'granted' | 'denied' | null;

export function getMarketingConsent(): MarketingConsent {
  try {
    const v = localStorage.getItem(KEY);
    if (v === 'granted' || v === 'denied') return v;
  } catch { /* ignore */ }
  return null;
}

export function setMarketingConsent(value: 'granted' | 'denied') {
  localStorage.setItem(KEY, value);
  window.dispatchEvent(new CustomEvent('em-marketing-consent', { detail: value }));
}

export function canLoadMarketingPixels(requireConsent: boolean): boolean {
  if (!requireConsent) return true;
  return getMarketingConsent() === 'granted';
}
